import { CommonModule } from '@angular/common';
import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { Input, ViewChild } from '@angular/core';

import { languageSupport, languageService } from '@unpispas/upp-base';
import { viewService } from '@unpispas/upp-base';

import { TicketView } from '@unpispas/upp-data';

import { UppWdgtModule } from '@unpispas/upp-wdgt';
import { UppInputComponent } from '@unpispas/upp-wdgt';

@Component({
    selector: 'upp-modal-cashpay',
    standalone: true,
    imports: [ CommonModule, FormsModule, IonicModule, UppWdgtModule ],
    templateUrl:'./upp-cash-modal.html',
    styleUrls: [
        './upp-cash-modal.scss'
    ]
})
export class UppCashPayModalComponent extends languageSupport implements OnInit {
    @Input() tickets: Array <TicketView> = [];
    @Output() OnAccept = new EventEmitter<{ amount: number | null }>();
    @Output() OnClose = new EventEmitter<void>();

    constructor(private lang: languageService, public view: viewService) {
        super(lang, null);
    }

    ngOnInit() {
        this._amountpaid = 0;
        for(const _ticket of this.tickets){
            if ((_ticket.status == 'PP') && (_ticket.given)){
                this._amountpaid += _ticket.given;
            }
        }
    }

    /********************************/
    /* DISPLAY OPTIONS              */
    /********************************/

    price(value: number): string{
        const _price: number = (Math.round(value * 100)/100);
        const _parts = Math.abs(_price).toString().split('.');

        const _int = _parts[0]
        const _dec = (_parts.length > 1) ? (_parts[1] + '0').slice(0, 2) : "00";

        return _int + ',' + _dec;
    }

    get AmountToPay(): number {
        let _totalprice = 0;

        for(const _ticket of this.tickets){
            _totalprice += Number(_ticket.due ?? _ticket.price ?? 0);
        }

        return _totalprice;
    }

    get CanAccept(){
        return !this.AmountReturn || (this.AmountReturn >= 0);
    }

    private _amountpaid = 0;
    get AmountPaid(): number | null {
        return this._amountpaid || null;
    }

    set AmountPaid(value: string){
        let _value: number = parseFloat(value);
        if (isNaN(_value) || (_value <= 0)){
            _value = 0;
        }

        this._amountpaid = _value;
    }

    get AmountReturn(): number {
        if (this.AmountPaid){
            return this.AmountPaid - this.AmountToPay;
        }
        return 0;
    }

    get AmountPending(): number {
        if (this.AmountPaid){
            return this.AmountToPay - this.AmountPaid;
        }
        return this.AmountToPay;
    }

    /***********************************/
    /* EVENT HANDLERS                  */
    /***********************************/

    @ViewChild('input', {static: false}) _input: UppInputComponent | null = null;

    OnNumPad(key: string){
        if (this._input){
            this._input.OnKeyPress(key);
        }
    }

    OnCash(value: string){
        if (this._input){
            this._input.value = value + ".00";
        }
    }

    OnAcceptClick() {
        (document.activeElement as HTMLElement)?.blur();
        this.OnAccept.emit({ amount: this.AmountPaid });
    }

    OnCloseClick() {
        (document.activeElement as HTMLElement)?.blur();
        this.OnClose.emit();
    }
}
